import './Divider.less'
import Divider from './Divider'

export type { DividerProps } from './iDivider'

export default Divider
